export enum CustomerDisplayImageResizeModeType {
  CONTAIN = "CONTAIN",
  COVER = "COVER",
}
